<template>
  <div>
    <v-btn 
      @click="getPreviewContent"
      v-track="'content-feed-preview'"
      dark
    >
      Preview
    </v-btn>
    
    <!-- Content Preview Dialog Start -->
    <v-dialog v-model="isPreviewEnabled" max-width="800">
      <v-card class="standard-modal">
        
        <v-card-title>
          <h4 class="secondary--font">{{ title }}</h4>
          <v-spacer></v-spacer>
          <v-btn
            v-track="'content-feed-preview-close'"
            icon
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="content-preview">
          <iframe id="previewIframe" src frameborder="0" style="width: 100%">
          </iframe>
        </div>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <!-- Content Preview Dialog End -->
  </div>
</template>
<script>
import { $dynamicContent } from "@/services";
export default {
  name: 'ContentFeedPreview',
  data(){
    return {
      isPreviewEnabled: false,
      content: '',
      loading: false,
    }
  },
  props:{
    htmlPart:{
      type: String,
      required: true,
    },
    contentFeedId:{
      type: Number,
    },
    title:{
      type: String,
      default: () => "Original Content Preview"
    }
  },
  methods:{
    closeDialog(){
      this.isPreviewEnabled = false;
    },
    getPreviewContent(){
      this.loading= true;
      const payload = {
        content_feed_id: this.contentFeedId,
        html_part : this.htmlPart
      }
       $dynamicContent.structuredContentPreview(payload)
       .then(res => {
        const response = res.data.data;
        if(!response.html_part){
          this.$store.commit('ui/snackbar',{
            message : 'Add content to render preview',
            type: 'error'
          })
        } else {
          this.content= response.html_part;
          this.isPreviewEnabled = true;
          setTimeout(() => {
            this.loadIframeContent();
          }, 100);
        }
       })
       .finally(() =>{
        this.loading = false;
       })
    },
    loadIframeContent(){
      
      var iframe = document.getElementById('previewIframe');
      if(iframe){
        iframe.height =''
        iframe.src = "about:blank";
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(this.content);
        iframe.height = iframe.contentWindow.document.body.scrollHeight + "px";
        iframe.contentWindow.document.close();
      }
      
    }
  }
};
</script>
<style scoped>
.content-preview{
  padding: 12px;
  margin: 20px 10px 0px 0px;
}
</style>
